module.exports = __webpack_public_path__ + "static/index/img/baikal-809.1df14857.jpg";